import React, { Component, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { useLocation } from 'react-router-dom';
import {
  Button,
  CurveHolder,
  StyledText,
} from "../../../components/common/basic";
import { Curve, NewBackButton } from "../../../components/svgs";

import { useTheme, useLoyalty, useAuth } from "../../../hooks";
import {
  Calender,
} from "../../../components/svgs";
import { formatDate } from "../../../services/utils";
import loadingGif from "../../../components/images/loader.gif";

const { REACT_APP_SERVER_URL: SERVER_URL } = process.env;

const Announcement = () => {
  let history = useHistory();
  const { themeContext, theme } = useTheme();
  const [activeEvent, setActiveEvent] = useState();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const eventId = queryParams.get('id');

  const {
    events,
    selectedEvent,
  } = useLoyalty();

  const {
    category,
    description,
    endTime,
    eventType,
    name,
    startTime,
    thumbnailUri,
    _id
  } = activeEvent || {};

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];

  useEffect(() => {
    if (eventId && events && events.length) {
      const foundEvent = events.find(ev => ev._id === eventId);
      setActiveEvent(foundEvent);
    }
  }, [eventId, events])

  useEffect(() => {
    if (selectedEvent && !eventId) {
      setActiveEvent(selectedEvent);
    }
  }, [selectedEvent, eventId]);

  if (!activeEvent) {
    return <MainHolder activeTheme={mashupBackground}>
      <Children>
        <BackButtonContainer
          onClick={() => {
            history.goBack();
          }}
        >
          <NewBackButton />
        </BackButtonContainer>
        <img
          alt={"dialog"}
          src={loadingGif}
          style={{ display: "block", width: "40px", margin: "80px auto" }}
        />
      </Children>
    </MainHolder>
  }

  return (
    <>
      <MainHolder activeTheme={mashupBackground}>
        <Children>
          <BackButtonContainer
            onClick={() => {
              history.goBack();
            }}
          >
            <NewBackButton />
          </BackButtonContainer>
          <img style={{ maxWidth: '100%' }} src={thumbnailUri} />

          <div
            style={{
              boxSizing: "border-box",
              padding: "10px 15px 40px 15px",
            }}
          >
            <StyledText size={18} style={{ margin: "10px 0 10px 0" }}>
              {name}
            </StyledText>
            <HorizontalLine />

            <IconList
              Icon={Calender}
              title={'Date'}
              description={formatDate(startTime || new Date())}
              color={background}
            />
            {
              description && <>
                <StyledText style={{ margin: "20px 0 5px 0" }}>
                  Details
                </StyledText>
                <StyledText style={{ fontFamily: "MTNRegular", margin: "0px 0 20px 0" }}>
                  {description}
                </StyledText>
              </>
            }
          </div>
        </Children>
      </MainHolder>
    </>
  );
};

const IconList = ({ Icon, title, description, color }) => (
  <div style={{ display: "flex", alignItems: "top", marginBottom: "15px" }}>
    <div
      style={{
        width: "16px",
        marginRight: "10px",
      }}
    >
      <Icon fill={color} width={16} height={16} />
    </div>
    <div>
      <StyledText
        size={14}
        style={{ fontFamily: "MTNBold", margin: "0 0 2px 0" }}
      >
        {title}
      </StyledText>
      <StyledText size={12} style={{ fontFamily: "MTNRegular", margin: "0" }}>
        {description}
      </StyledText>
    </div>
  </div>
);

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  scrollbar-width: none;
  background-color: ${({ activeTheme }) => activeTheme};
  height: 700px;
  position: relative;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: inherit;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  margin: 20px;
  z-index: 2;
`;

const HorizontalLine = styled.div`
  margin: 20px 0;
  border-top: none;
  border-bottom: 1px solid #ddd;
`;

export default Announcement;
